<div class="p-2" style="margin-bottom: 7px;">
  <p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" [styleClass]="infoCollapsed ? 'p-panel-outline-light' : 'p-panel-outline'">
    <ng-template pTemplate="header">
      <div class="flex align-items-center">
        <i class="pi pi-info-circle"></i>
        <p class="ml-2 mb-0" style="margin-top: 1px;">{{'common.information' | transloco}}</p>
      </div>
    </ng-template>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.measurementsStep.basic' | transloco" class="inline"></p>
      <p-badge value="1" class="mx-1" severity="success"></p-badge>.
    </div>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.measurementsStep.totalElements' | transloco" class="inline"></p>
      <p-badge value="2" class="mx-1" severity="success"></p-badge>.
    </div>

    <div class="px-3 py-2">
      <p [innerHTML]="'info.kpisForm.measurementsStep.duplicatedElements' | transloco" class="inline"></p>.
    </div>

    <p-tabMenu
      [model]="demoMeasurementTabs"
      [activeItem]="demoMeasurementTabsActive"
      styleClass="flex justify-content-center p-disabled"
    >
      <ng-template pTemplate="item" let-item let-i="index">
        <div class="flex align-items-center">
          <i [class]="item.icon"></i>{{item.label | transloco}}
          <div *ngIf="item.id == 'deviceMeasurements'" class="ml-1"> (3)</div>
          <p-badge *ngIf="item.id == 'deviceMeasurements'" value="2" class="mx-1" severity="success"></p-badge>
          <div *ngIf="item.id == 'assetMeasurements'" class="ml-1 pt-1"> (0)</div>
          <div *ngIf="item.id == 'kpis'" class="ml-1 pt-1"> (2)</div>
        </div>
      </ng-template>
    </p-tabMenu>
    <div class="mt-2">
      <div class="flex justify-content-center align-items-center pt-2 pb-3">
        <p-badge value="1" class="mx-1" severity="success"></p-badge>
        <button
          [label]="'select.deviceSensors' | transloco"
          pButton
          pRipple
          disabled
        ></button>
      </div>
      <div class="p-datatable p-component">
        <p-table
          [value]="demoDeviceMeasurements"
          [totalRecords]="demoDeviceMeasurements.length"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          styleClass="p-datatable-striped"
          sortField="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-18rem" pSortableColumn="device.serialNumber">
                {{'model.device' | transloco}}
                <p-sortIcon field="device.serialNumber"></p-sortIcon>
              </th>
              <th class="w-18rem" pSortableColumn="name">
                {{'model.sensor' | transloco}}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="description">
                {{'attribute.description' | transloco}}
                <p-sortIcon field="description"></p-sortIcon>
              </th>
              <th pSortableColumn="measurementType.sensor">
                {{'model.sensorType' | transloco}}
                <p-sortIcon field="measurementType.sensor"></p-sortIcon>
              </th>
              <th class="w-4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-measurement>
            <tr>
              <td>
                <span class="p-column-title bold">{{'model.device' | transloco}}</span>
                {{measurement.device.serialNumber}}
              </td>
              <td>
                <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
                <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                {{measurement.description}}
              </td>
              <td>
                <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
                {{measurement.measurementType?.sensor ?? ''}}
              </td>
              <td class="p-0">
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    class="p-button-rounded btn-danger-light mr-2 border-none"
                    pButton
                    pRipple
                    disabled
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>

<p-tabMenu
  [model]="measurementTabs"
  [activeItem]="measurementTabsActive"
  styleClass="flex justify-content-center"
  #measurementsTabMenu
>
  <ng-template pTemplate="item" let-item let-i="index">
    <i [class]="item.icon"></i>{{item.label | transloco}}
    <div *ngIf="item.id == 'deviceMeasurements'" class="ml-1"> ({{ deviceMeasurements.length }})</div>
    <div *ngIf="item.id == 'assetMeasurements'" class="ml-1"> ({{ assetMeasurements.length }})</div>
    <div *ngIf="item.id == 'kpis'" class="ml-1"> ({{ kpis.length }})</div>
  </ng-template>
</p-tabMenu>

<div class="flex flex-column mb-3">
  <div class="mt-2" *ngIf="deviceMeasurements && measurementsTabMenu.activeItem.id === 'deviceMeasurements'">
    <app-device-measurements-selector
      [(visible)]="displayDeviceMeasurementSelector"
      [(selection)]="deviceMeasurements"
      [tenant]="kpiInfoForm.get('tenant').value"
      [organization]="kpiInfoForm.get('organization').value"
      (selectionChange)="deviceMeasurementsChange.emit($event)"
      selectionMode="multiple"
    ></app-device-measurements-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!kpiInfoForm.get('tenant').value"
        (click)="displayDeviceMeasurementSelector = true"
        [label]="'select.deviceSensors' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="deviceMeasurementsFirst"
        [(rows)]="deviceMeasurementsRows"
        [value]="deviceMeasurements"
        [totalRecords]="deviceMeasurements.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #deviceMeasurementsTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-18rem" pSortableColumn="device.serialNumber">
              {{'model.device' | transloco}}
              <p-sortIcon field="device.serialNumber"></p-sortIcon>
            </th>
            <th class="w-18rem" pSortableColumn="name">
              {{'model.sensor' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="measurementType.sensor">
              {{'model.sensorType' | transloco}}
              <p-sortIcon field="measurementType.sensor"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-measurement>
          <tr>
            <td>
              <span class="p-column-title bold">{{'model.device' | transloco}}</span>
              {{measurement.device.serialNumber}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{measurement.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
              {{measurement.measurementType?.sensor ?? ''}}
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeDeviceMeasurement(measurement); deviceMeasurementsTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="mt-2" *ngIf="assetMeasurements && measurementsTabMenu.activeItem.id === 'assetMeasurements'">
    <app-asset-measurements-selector
      [(visible)]="displayAssetMeasurementSelector"
      [(selection)]="assetMeasurements"
      [tenant]="kpiInfoForm.get('tenant').value"
      [organization]="kpiInfoForm.get('organization').value"
      (selectionChange)="assetMeasurementsChange.emit($event)"
      selectionMode="multiple"
    ></app-asset-measurements-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!kpiInfoForm.get('tenant').value"
        (click)="displayAssetMeasurementSelector = true"
        [label]="'select.assetSensors' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="assetMeasurementsFirst"
        [(rows)]="assetMeasurementsRows"
        [value]="assetMeasurements"
        [totalRecords]="assetMeasurements.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #assetMeasurementsTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-18rem" pSortableColumn="asset.alias">
              {{'model.asset' | transloco}}
              <p-sortIcon field="asset.alias"></p-sortIcon>
            </th>
            <th class="w-18rem" pSortableColumn="name">
              {{'model.sensor' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="measurementType.sensor">
              {{'model.sensorType' | transloco}}
              <p-sortIcon field="measurementType.sensor"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-measurement>
          <tr>
            <td>
              <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
              {{measurement.asset.alias}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{measurement.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
              {{measurement.measurementType?.sensor ?? ''}}
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeAssetMeasurement(measurement); assetMeasurementsTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="mt-2" *ngIf="kpis && measurementsTabMenu.activeItem.id === 'kpis'">
    <app-kpis-selector
      [(visible)]="displayKpisSelector"
      [kpis]="kpis"
      [actionButtons]="selectKpisActions"
      [tenant]="kpiInfoForm.get('tenant').value"
      [organization]="kpiInfoForm.get('organization').value"
    ></app-kpis-selector>
    <div class="flex justify-content-center pt-2 pb-3">
      <button
        [disabled]="!kpiInfoForm.get('tenant').value"
        (click)="displayKpisSelector = true"
        [label]="'select.kpis' | transloco"
        pButton
        pRipple
      ></button>
    </div>
    <div class="p-datatable p-component">
      <p-table
        [(first)]="kpisFirst"
        [(rows)]="kpisRows"
        [value]="kpis"
        [totalRecords]="kpis.length"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        styleClass="p-datatable-striped"
        sortField="name"
        #kpisTable
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">
              {{'attribute.name' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}
              <p-sortIcon field="description"></p-sortIcon>
            </th>
            <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
              {{'model.organization' | transloco}}
              <p-sortIcon field="organization.name"></p-sortIcon>
            </th>
            <th class="w-4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-kpiRow>
          <tr>
            <td>
              <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.description}}</p>
            </td>
            <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
              <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
              <p class="text-right md:text-left">{{kpiRow.organization?.name}}</p>
            </td>
            <td class="p-0">
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  (click)="removeKpi(kpiRow); kpisTable._filter()"
                  class="p-button-rounded btn-danger-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

